// One line per availability warning for Build Schedule's "Shift saved — but
// heads up" alert. Kinds come from availabilityWarnings in
// server/features/schedule/helpers.js; an unrecognised kind falls back to its name.
export function shiftWarningLine(w) {
  if (w.kind === 'full_day_off')  return `• Employee marked themselves OFF this day${w.note ? ` (${w.note})` : ''}`;
  if (w.kind === 'tor_full_day')  return `• Approved time-off covers this day${w.note ? ` (${w.note})` : ''}`;
  if (w.kind === 'time_range')    return `• NA window ${w.range}${w.note ? ` — ${w.note}` : ''}`;
  if (w.kind === 'tor_partial')   return `• Approved time-off window ${w.range}${w.note ? ` — ${w.note}` : ''}`;
  if (w.kind === 'outside_availability') return `• Outside the hours they said they CAN work (${w.range})${w.note ? ` — ${w.note}` : ''}`;
  return `• ${w.kind}`;
}
